import { isEmbedded } from '../lib/PageHelpers.js';
import React, { useContext } from 'react';
import { ThemeContext } from '../../lib/ThemeContext.js';
import PoweredBy from '~/public/components/PoweredBy';

const PageContainer = ({ children, styles, hidePoweredBy }) => {
    const { styles: themeStyles } = useContext(ThemeContext);

    styles = styles || themeStyles;
    const hasFullBackground =
        !!styles?.fullPageImage &&
        (!!styles?.headerImage || !!styles?.headerColor);

    return (
        <div>
            <PoweredBy className="pt-4 mb-4" showOnlyFree={true} />

            <div
                className={
                    (hasFullBackground ? '!pt-0 sm:!pt-4 ' : '') +
                    (!isEmbedded()
                        ? 'min-h-screen w-full pt-4 mx-auto'
                        : '')
                }
            >
                    <div
                        className={
                            hasFullBackground
                                ? `${!isEmbedded() ? '' : ''} bg-[#FFFFFFAA] mb-4 p-3 sm:p-6 rounded-xl backdrop-blur has-full-background max-w-[1050px] mx-auto w-full md:w-auto`
                                : 'no-full-background max-w-[1050px] mx-auto px-4 w-full'
                        }
                    >
                        {children}
                    </div>
                    {!hidePoweredBy && <PoweredBy className="mt-6 pb-4" />}
                </div>
        </div>
    );
};

export default PageContainer;
